import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { commonFunctions } from 'utils/CommonFunctions'
import { last } from 'lodash'

export const BENEFICIARY_GET = 'BENEFICIARY_GET'
export const BENEFICIARY_RECEIVED = 'BENEFICIARY_RECEIVED'
export const BENEFICIARY_GET_ERROR = 'BENEFICIARY_GET_ERROR'

export const BENEFICIARY_SAVING = 'BENEFICIARY_SAVING'
export const BENEFICIARY_SAVING_COMPLETE = 'BENEFICIARY_SAVING_COMPLETE'
export const BENEFICIARY_SAVING_ERROR = 'BENEFICIARY_SAVING_ERROR'

export const BENEFICIARY_LOCK_GET = 'BENEFICIARY_LOCK_GET'
export const BENEFICIARY_LOCK_RECEIVED = 'BENEFICIARY_LOCK_RECEIVED'
export const BENEFICIARY_LOCK_GET_ERROR = 'BENEFICIARY_LOCK_GET_ERROR'

const saving = type => ({
  type,
})

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const beneficiaryReceive = (beneficiaries, beneficiary) => ({
  type: BENEFICIARY_RECEIVED,
  beneficiaries,
  beneficiary,
})

const beneficiaryLockedStatusAndRemReceive = (locked, fixedRem, fixedAmount, effectiveDate, comments) => ({
  type: BENEFICIARY_LOCK_RECEIVED,
  isLocked: locked,
  fixedRem,
  fixedAmount,
  effectiveDate,
  comments,
})



export function getBeneficiaries(employeeId) {
  return (dispatch, getState) => {
    dispatch(fetching(BENEFICIARY_GET))
    agent.Beneficiary.list(employeeId).then((response) => {
      const beneficiaries = response.map(beneficiary => ({
        employeeId: beneficiary.employee_id,
        beneficiaryId: beneficiary.beneficiary_id,
        firstName: beneficiary.first_name,
        lastName: beneficiary.last_name,
        companyName: beneficiary.company_name,
        trustName: beneficiary.trust_name,
        trusteeName: beneficiary.trustee_name,
        type: beneficiary.beneficiary_type,
        dob: beneficiary.date_of_birth,
        tfn: beneficiary.tfn,
        amountType: beneficiary.beneficiary_amount_type,
        amount: (beneficiary.beneficiary_amount_type ? commonFunctions.iff(beneficiary.beneficiary_amount_type.toLowerCase() !== 'max', beneficiary.amount_allocated, '0') : '0'),
        effectiveDate: beneficiary.effective_date,
        address1: beneficiary.address1,
        address2: beneficiary.address2,
        suburb: beneficiary.suburb,
        city: beneficiary.city,
        state: beneficiary.state,
        postcode: beneficiary.postcode,
        country: beneficiary.country,
        year: beneficiary.year,
        fixedAmount: beneficiary.fixed_amount,
        fixedRem: beneficiary.fixed_rem,
        amountMax: beneficiary.amount_max,
        amountMin: beneficiary.amount_min,
      }))

      // eslint-disable-next-line no-shadow
      const [beneficiaryCurrentFy] = [...new Set(beneficiaries.filter(beneficiaryCurrentFy => beneficiaryCurrentFy.year === Number(getState().beneficiaries.currentFy.current.year)))]
      let beneficiary = {}
      if (beneficiaryCurrentFy) {
        beneficiary = beneficiaryCurrentFy
      }

      dispatch(beneficiaryReceive(beneficiaries, beneficiary))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getBeneficiaries>: ', description, error)
        dispatch(fetchingerror(BENEFICIARY_GET_ERROR))
      }
    })
  }
}

export function getBeneficiaryLockedStatusAndRem(employeeId) {
  return (dispatch) => {
    dispatch(fetching(BENEFICIARY_LOCK_GET))
    agent.Beneficiary.lockandrem(employeeId).then((response) => {
      dispatch(beneficiaryLockedStatusAndRemReceive(response[0].is_locked, response[0].fixed_rem, response[0].fixed_amount, response[0].effective_date, response[0].comments))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getBeneficiaryLockedStatusAndRem>: ', description, error)
        dispatch(fetchingerror(BENEFICIARY_LOCK_GET_ERROR))
      }
    })
  }
}

export function confirmBeneficiary(beneficiarydata) {
  return (dispatch) => {
    dispatch(saving(BENEFICIARY_SAVING))
    agent.Beneficiary.confirm(beneficiarydata).then((response) => {
      dispatch(saving(BENEFICIARY_SAVING_COMPLETE))
      dispatch(notify('Beneficiary confirmed'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <confirmBeneficiary>: ', description, error)
        dispatch(fetchingerror(BENEFICIARY_SAVING_ERROR))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/beneficiaries.js